/**
 * Checks for an ambassador ID in the URL params and retrieves the related SL cookies.
 *
 * If an ambassador ID is present in the URL params, we parse it and make 2 requests to SocialLadder via getSLCookie:
 * - sl-shop-code: represents the code of our store as set by SocialLadder
 * - sl-track-purchase: represents the unique tracking cookie for the customer's order
 *
 * Once the order is completed in checkout.liquid, we send a final request to SL using the SLCheckout method.
 */

/**
 * Get the ambassadorID URL param.
 *
 * @returns {string} ambassadorID - The ID appended to the ambassador's unique sharing link.
 */
const getSocialLadderAmbassadorID = () => {
  const allParams = new URLSearchParams(window.location.search);
  const ambassadorID = allParams.get("ambassadorID");
  return ambassadorID;
};

const SLAmbassadorID = getSocialLadderAmbassadorID();

// If an ambassador ID exists, check if we need to set the cookie.
if (SLAmbassadorID) {
  if (!window.getCookie("sl-track-purchase")) {
    // Gets the cookies from SL and stores them in the browser.
    window.getSLCookie("sl-shop-code");
    window.getSLCookie("sl-track-purchase");
  }
}
